
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import { ProjectUser } from '@/views/Authorization/types/projectUser'
import { HseContact } from '@/views/Project/HSE/types/hseContact'
import { searchProjectUsers } from '@/views/Authorization/utils/authorization'
import { getHseContacts } from '@/utils/hse'
import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import ProjectUserTr from '@/views/Project/ProjectUsers/components/projectUser.vue'
import lodash from 'lodash'
import ProjectMixin from '@/_mixins/project'

const ProjectUsers = Vue.extend({
    mixins: [AppMixin, ProjectMixin],
    components: { ToolbarComponent, ProjectUserTr },
    props: {},

    data() {
        return {
            authorized: true,
            loaded: false,
            debounceisOn: false,
            minSearchTermLength: 2,
            searchTerm: '',
            limit: 20,
            offset: 0,
            infiniteID: 0,
            sort: [], //'isPending, userFullName,email'
            projectUsers: [] as ProjectUser[],
            hseContacts: [] as HseContact[],
        }
    },

    methods: {
        async searchProjectUsers() {
            let filters = {
                'filter[userKindIfConfirmed]': 'normal',
                'filter[project]': this.currentProjectId,
                'filter[hasRoles]': true,
                ...(this.searchTerm &&
                    this.searchTerm.length >= this.minSearchTermLength && {
                        'filter[searchTerm]': this.searchTerm,
                    }),
                ...(!!this.userId && { 'filter[user]': this.userId }),
                ...(this.sort.length > 0 && { sort: this.sort.join(',') }),
                'page[offset]': this.offset,
                'page[limit]': this.limit,
            }

            let res = await searchProjectUsers(filters)

            this.projectUsers = [...this.projectUsers, ...res]

            return res
        },
        async handleUsers($state: any) {
            if (
                this.currentProjectId &&
                (!this.searchTerm || this.searchTerm.length >= this.minSearchTermLength)
            ) {
                let res = await this.searchProjectUsers()

                if (res.length > 0) {
                    if (res.length == this.limit) {
                        this.offset += this.limit
                        $state.loaded()
                    } else {
                        $state.loaded()
                        $state.complete()
                    }
                } else {
                    $state.complete()
                }
            }

            this.debounceisOn = false
        },
        delaySearch: lodash.debounce(function (this) {
            if (!this.searchTerm || this.searchTerm.length >= this.minSearchTermLength) {
                this.offset = 0
                this.infiniteID += 1
            } else {
                this.debounceisOn = false
            }
        }, 800),
        async loadHSEContacts() {
            this.hseContacts = await getHseContacts(this.currentProjectId)
        },
        hseContactAdded(hseContact: HseContact) {
            this.hseContacts.push(hseContact)
        },
    },

    watch: {
        currentProjectId: {
            immediate: true,
            async handler() {
                if (!this.hasError) {
                    this.debounceisOn = true
                    this.offset = 0
                    this.infiniteID += 1
                    this.projectUsers = []
                    await this.loadHSEContacts()
                }
            },
        },
        searchTerm: {
            immediate: false,
            handler() {
                this.debounceisOn = true
                this.projectUsers = []
                this.delaySearch()
            },
        },
    },

    // Is temporary solution  to update hse contacts after adding new contact
    async beforeDestroy() {
        if (!this.$route.params.id) return

        await this.getProject(this.$route.params.id)
    },
})

export default ProjectUsers
